import React from "react";
import { useNavigate } from "react-router-dom";
import { SouthAfricanRand } from "../../utils/helpers";
import { Box, Button, Divider, Grid, Paper, Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForwardOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { COLORS } from "../../constants";

export const CartSummary = ({
  vat,
  cartNettTotal,
  logisticsFee,
  settlementAmount,
  vatAmount,
  total,
  buttonText,
  onButtonClick,
  buttonDisabled,
}) => {
  const navigate = useNavigate();
  const deliveryFeeToDisplay = () => {
    if (!!logisticsFee || logisticsFee === 0) {
      if (logisticsFee > 0) {
        return SouthAfricanRand.format(logisticsFee);
      } else {
        return "Free";
      }
    } else {
      return "TBD";
    }
  };

  return (
    <>
      <Paper
        sx={{
          padding: 3,
          border: `1px solid ${COLORS.border}`,
          borderRadius: "2px",
          width: "100%",
          maxWidth: 400,
          margin: "auto",
          boxShadow: "none",
        }}
      >
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" fontWeight="500" align="center">
            Order Summary
          </Typography>
        </Box>
        <Divider sx={{ mb: 2, borderColor: COLORS.border }} />

        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography
              variant="caption"
              component="p"
              sx={{ color: COLORS.lightText }}
            >
              Nett Total
            </Typography>
          </Grid>
          <Grid item xs={6} textAlign="right">
            <Typography variant="caption" fontWeight="500" component="p">
              {SouthAfricanRand.format(cartNettTotal)}
            </Typography>
          </Grid>

          {!!settlementAmount && settlementAmount > 0 && (
            <>
              <Grid item xs={6}>
                <Typography
                  variant="caption"
                  component="p"
                  sx={{ color: COLORS.lightText }}
                >
                  Settlement Discount
                </Typography>
              </Grid>
              <Grid item xs={6} textAlign="right">
                <Typography variant="caption" color="error" component="p">
                  -{SouthAfricanRand.format(settlementAmount)}
                </Typography>
              </Grid>
            </>
          )}

          <Grid item xs={6}>
            <Typography
              variant="caption"
              component="p"
              sx={{ color: COLORS.lightText }}
            >
              VAT ({vat}%)
            </Typography>
          </Grid>
          <Grid item xs={6} textAlign="right">
            <Typography variant="caption" fontWeight="500" component="p">
              {SouthAfricanRand.format(vatAmount)}
            </Typography>
          </Grid>

          {!!logisticsFee && (
            <>
              <Grid item xs={6}>
                <Typography
                  variant="caption"
                  component="p"
                  sx={{ color: COLORS.lightText }}
                >
                  Delivery Fee
                </Typography>
              </Grid>
              <Grid item xs={6} textAlign="right">
                <Typography variant="caption" fontWeight="500" component="p">
                  {deliveryFeeToDisplay()}
                </Typography>
              </Grid>
            </>
          )}

          <Divider
            sx={{
              width: "100%",
              my: 2,
              borderStyle: "dotted",
              borderColor: COLORS.gray,
              height: "20px",
              margin: "0 10px",
            }}
          />

          <Grid item xs={6}>
            <Typography variant="body2" fontWeight="500">
              Total
            </Typography>
          </Grid>
          <Grid item xs={6} textAlign="right">
            <Typography
              variant="body2"
              fontWeight="500"
              sx={{ color: COLORS.themeRed }}
            >
              {SouthAfricanRand.format(total)}
            </Typography>
          </Grid>
        </Grid>
      </Paper>
      <Button
        variant="contained"
        color="error"
        size="small"
        fullWidth
        disabled={buttonDisabled}
        onClick={onButtonClick}
        endIcon={<ArrowForwardIcon fontSize="small" />}
        sx={{
          marginTop: "0.75rem",
          borderRadius: "2px",
          boxShadow: "none",
          p: 1,
        }}
      >
        {buttonText}
      </Button>
      <Button
        variant="contained"
        size="small"
        fullWidth
        onClick={() => navigate(`/products/service_parts`)}
        startIcon={<ArrowBackIcon fontSize="small" />}
        sx={{
          marginTop: "0.75rem",
          borderRadius: "2px",
          boxShadow: "none",
          p: 1,
          color: COLORS.themeRed,
          backgroundColor: COLORS.white,
          border: `1px solid ${COLORS.themeRed}`,
        }}
      >
        Continue shopping
      </Button>
    </>
  );
};
